// Curated premium font pairings (heading + body). The builder previews all six;
// a microsite loads ONLY its chosen pairing (preconnect + display=swap).

export const FONT_PAIRINGS = {
  equus: {
    label: "Equus",
    heading: '-apple-system, "SF Pro Display", Inter, sans-serif',
    body: '-apple-system, "SF Pro Display", Inter, sans-serif',
    gf: null, // system stack — nothing to load
  },
  classic: {
    label: "Classic",
    heading: '"Playfair Display", Georgia, serif',
    body: '"Inter", -apple-system, sans-serif',
    gf: "family=Playfair+Display:wght@400;500;600&family=Inter:wght@400;500;600",
  },
  heritage: {
    label: "Heritage",
    heading: '"Fraunces", Georgia, serif',
    body: '"Inter", -apple-system, sans-serif',
    gf: "family=Fraunces:opsz,wght@9..144,400;9..144,500;9..144,600&family=Inter:wght@400;500;600",
  },
  editorial: {
    label: "Editorial",
    heading: '"Newsreader", Georgia, serif',
    body: '"Inter", -apple-system, sans-serif',
    gf: "family=Newsreader:opsz,wght@6..72,400;6..72,500&family=Inter:wght@400;500;600",
  },
  geometric: {
    label: "Geometric",
    heading: '"Outfit", -apple-system, sans-serif',
    body: '"Inter", -apple-system, sans-serif',
    gf: "family=Outfit:wght@400;500;600&family=Inter:wght@400;500;600",
  },
  contemporary: {
    label: "Contemporary",
    heading: '"Manrope", -apple-system, sans-serif',
    body: '"Manrope", -apple-system, sans-serif',
    gf: "family=Manrope:wght@400;500;600;700",
  },
};

const loaded = new Set();

function preconnect() {
  if (document.querySelector('link[data-gf-preconnect]')) return;
  for (const href of ["https://fonts.googleapis.com", "https://fonts.gstatic.com"]) {
    const link = document.createElement("link");
    link.rel = "preconnect";
    link.href = href;
    if (href.includes("gstatic")) link.crossOrigin = "anonymous";
    link.setAttribute("data-gf-preconnect", "1");
    document.head.appendChild(link);
  }
}

/** Load one pairing's webfonts (idempotent). */
export function ensurePairingLoaded(key) {
  const pairing = FONT_PAIRINGS[key];
  if (!pairing?.gf || loaded.has(key)) return;
  preconnect();
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = `https://fonts.googleapis.com/css2?${pairing.gf}&display=swap`;
  document.head.appendChild(link);
  loaded.add(key);
}

/** Builder only: load every pairing for live previews. */
export function ensureAllPairingsLoaded() {
  Object.keys(FONT_PAIRINGS).forEach(ensurePairingLoaded);
}
